import { cj } from 'src/utils/classNames';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

function ChartTooltipRoot({
	className,
	children,
}: WithClassName<WithChildren>) {
	return (
		<div
			className={cj(
				'flex max-w-60 min-w-50 flex-col gap-y-xs rounded-sm bg-tooltip-bg p-sm shadow-sm',
				'typo-b4 text-text-default',
				className
			)}
		>
			{children}
		</div>
	);
}

function ChartTooltipRow({ className, children }: WithClassName<WithChildren>) {
	return (
		<div
			className={cj(
				'flex w-full items-center justify-between gap-x-lg',
				className
			)}
		>
			{children}
		</div>
	);
}

export default {
	Root: ChartTooltipRoot,
	Row: ChartTooltipRow,
};
